// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datacapture_container_datacapture__SRuFm{
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: baseline;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}
 


.datacapture_featured__ChN2p {
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;
  justify-content: space-between;
} 

.datacapture_container_row__1UAbr{
  display: flex;
  flex: 1 1; 

  flex-direction: column;
  align-content: center;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: space-around;
}

.datacapture_printviewDialog__q\\+uFM {
  min-width: 90vw !important;
  max-width: 90vw !important;
}

.datacapture_confirmDialogOverlay__FsKQG {
  z-index: 10000; 
  pointer-events: none;
}

 .datacapture_btn_inline__bBLb4 {
  display: inline-block;
  border-radius: 50px;
  background-color: var(--hsrcOrange);
  border-color: var(--hsrcOrange);
  border-style: solid;
  border-width: 1rem;
  color: var(--hsrcWhite);
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  transition: all 0.5s;
  /* margin: 15px; */
  letter-spacing: 0.15rem;
  cursor: pointer;
  height: 30px;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/Datacapture/datacapture.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;;;AAIA;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAO;;EAEP,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;CAEC;EACC,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,WAAW;AACb","sourcesContent":[".container_datacapture{\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: baseline;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n \r\n\r\n\r\n.featured {\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n} \r\n\r\n.container_row{\r\n  display: flex;\r\n  flex: 1; \r\n\r\n  flex-direction: column;\r\n  align-content: center;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: space-around;\r\n}\r\n\r\n.printviewDialog {\r\n  min-width: 90vw !important;\r\n  max-width: 90vw !important;\r\n}\r\n\r\n.confirmDialogOverlay {\r\n  z-index: 10000; \r\n  pointer-events: none;\r\n}\r\n\r\n .btn_inline {\r\n  display: inline-block;\r\n  border-radius: 50px;\r\n  background-color: var(--hsrcOrange);\r\n  border-color: var(--hsrcOrange);\r\n  border-style: solid;\r\n  border-width: 1rem;\r\n  color: var(--hsrcWhite);\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  transition: all 0.5s;\r\n  /* margin: 15px; */\r\n  letter-spacing: 0.15rem;\r\n  cursor: pointer;\r\n  height: 30px;\r\n  width: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_datacapture": `datacapture_container_datacapture__SRuFm`,
	"featured": `datacapture_featured__ChN2p`,
	"container_row": `datacapture_container_row__1UAbr`,
	"printviewDialog": `datacapture_printviewDialog__q+uFM`,
	"confirmDialogOverlay": `datacapture_confirmDialogOverlay__FsKQG`,
	"btn_inline": `datacapture_btn_inline__bBLb4`
};
export default ___CSS_LOADER_EXPORT___;
